<ca-entity-history
  [loading]="loadingHistory$ | async"
  [history]="history$ | async"
  [members]="members$ | async"
></ca-entity-history>
